'use client';

import type { Route } from 'next';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import FormCheckbox from '../../../components/form/FormCheckbox/FormCheckbox';
import FormText from '../../../components/form/FormText/FormText';
import FaIcon, { faSearch } from '../../../components/icon/FaIcon/FaIcon';
import utilsStyles from '../../../styles/modules/utils.module.scss';
import styles from './DeliverySearch.module.scss';

export type DeliverySearchProps = {
  query?: string;
  hasCheckBox?: boolean;
  isStatus?: string;
};

function DeliverySearch({ query, hasCheckBox = true, isStatus = '' }: DeliverySearchProps) {
  const router = useRouter();
  const { handleSubmit, getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      status: isStatus ? ['status'] : [],
      searchText: query || '',
    },
  });

  const onChangeCheck = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('status').length > 0) {
      params.set('status', String(true));
    } else {
      params.delete('status');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  const textSearch = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('searchText').length > 0) {
      params.set('q', getValues('searchText'));
    } else {
      params.delete('q');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  const onChangeText = () => {
    textSearch();
  };

  const submitText = async () => {
    textSearch();
  };

  return (
    <>
      <div className={utilsStyles.mtSmall}>
        <form onSubmit={handleSubmit(submitText)}>
          <FormText
            name='searchText'
            control={control}
            outlined
            placeholder='イベント名を検索できます'
            prefix={
              <div className={styles.searchIcon}>
                <FaIcon icon={faSearch} size='xl' />
              </div>
            }
            onChange={onChangeText}
          />
        </form>
      </div>

      <div className={utilsStyles.mtSmall}>
        {query && (
          <div className={utilsStyles.mtXSmall}>
            <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>“{query}”の検索結果</p>
          </div>
        )}
      </div>
      {hasCheckBox && (
        <div className={utilsStyles.mtSmall}>
          <FormCheckbox
            name='status'
            items={[
              {
                value: 'status',
                child: <>未配送の配送のみを表示する</>,
              },
            ]}
            control={control}
            onChange={onChangeCheck}
          />
        </div>
      )}
    </>
  );
}

export default DeliverySearch;
